import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: 'イノベーション ワークショップ',
  title1: 'イノベーション ワークショップ',
  introduction_text:
    '新たな事業アイデアを創出するワークショップを実施しました。このワークショップは中期経営方針を実現するために、全体最適実現のためのアイデアを網羅的に創出しました。イノベーション理論を用いたワークを行い、30個以上のアイデアを出しデジタルプロジェクト進行の支援まで実施しました。',
  company: 'カヤバ株式会社',
  tag1text: '組織開発・人材育成',
  tag1src: '/cases/hip/',
  industryTagText: 'メーカー/製造/建設',
  industryTagSrc: '/cases/manufacturing/',
  color: '',
  background: '#F8F8F8',
  staff1: '',
  image: '/images/img/cases/caseStudyTop/kayaba.webp',
  alt: 'イノベーション ワークショップ',
  imgClass: 'fv_img_adjust1',
  noProtrude: true,
}

// プロジェクト概要
export const overviewTitle = '中期経営計画実現のためのワークショップご支援'
export const overviewItem: OverviewItems[] = [
  {
    text: '東京証券取引所プライム市場に上場しているカヤバ株式会社様（以下カヤバ様）にてワークショップを実施いたしました。カヤバ様は多くの自動車メーカー様向けにショックアブソーバーなどの油圧システム製品を製造販売しており、グローバルで大きなシェアを占めております。',
  },
  {
    text: 'カヤバ様では、革新的モノづくりの推進と、デジタル技術を活用した競争力・独自性のあるモノづくりへの取り組みなど、「デジタル技術の活用と融合でイノベーションを起こす」ことを中期経営方針として掲げており、それらを実現できる人財育成の取り組みの一環として当ワークショップを採用いただきました。',
  },
  {
    text: '当ワークショップでは前半の破壊的イノベーション フレームワークで参加者の思考の枠を外し、新たな事業アイデアをアウトプットしていただきました。後半では、持続的イノベーション フレームワークにて組織における脱サイロ的視点での全体最適を実現するためのアイデアを網羅的に30個超出して頂く結果で閉会いたしました。',
  },
  {
    text: 'その後、アフターワークショップではそれらの打ち手に対し優先度付けを行い、経営サイドに上申。デジタルプロジェクト化すべく現在進行していただいております。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: '経営方針はあるが、実現までのロードマップが見えていない',
        text: '',
      },
      {
        title: 'ミドルマネジメント層のDXリテラシー向上',
        text: '',
      },
      {
        title: 'アイデアをデジタルプロジェクトへと昇華させるスキル',
        text: '',
      },
    ],
    solutions: [
      {
        title: '経営方針実現のための課題をワークショップで抽出',
        text: '',
      },
      {
        title: 'アウトプット中心の実践型ワークショップでスキルとマインドの醸成',
        text: '',
      },
      {
        title: 'デジタルプロジェクト立案に向けて伴走支援',
        text: '',
      },
    ],
  },
]

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
